import { Component } from 'react';

import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import _, { flowRight as compose } from 'lodash';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'providers';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';

import JMiniStopBox from 'components/JMiniStopBox';
import AssignmentMap from '../../../components/AssignmentMap';
import TimeWindow from '../../../components/TimeWindow';
import AssignmentNote from '../../../components/AssignmentNote';
import { HistoryListComponent } from '../../../components/HistoryList';
import { MAP_SHIPMENT_STATUS_TO_COLORS } from '../../../constants/colors';
import { convertMeterToMile } from '../../../constants/common';
import * as E from './styles';

class AssignmentDetailPanel extends Component {
  selectStop = (stop) => {
    const { shipmentStore, messengerStore } = this.props.store;

    if (stop) {
      shipmentStore.selectStop(stop);
      messengerStore.setStopSelected(stop);
      this.props.onChangePanel('shipmentDetail');
    }
  };

  render() {
    const { messengerStore, userStore } = this.props.store;
    const { user } = userStore;
    const { assignmentInfoInTopicSelected, filteredShowingStops, stopSelected } = messengerStore;

    if (!assignmentInfoInTopicSelected) return;

    const { assignment, extra } = assignmentInfoInTopicSelected || {};
    const { stops, shipmentLabels } = assignmentInfoInTopicSelected || [];
    const mapLogisticToType = { NEXT_DAYS: 'Next-day', SAME_DAY: 'Same-day' };
    const statusColor = _.defaultTo(MAP_SHIPMENT_STATUS_TO_COLORS[_.get(assignment, 'status', null)], '#bebebe');
    const counter = assignment?.shipment_count ? assignment.shipment_count : null;
    const completedCounter =
      extra?.dropoff_status
        ? extra.dropoff_status.split('|').filter((a) => a === 'DF' || a === 'DS' || a === 'DL' || a === 'DE').length
        : null;
    const pendingStops = (stops && stops.filter((s) => s.type === 'DROP_OFF' && s.status === 'PENDING')) || [];
    const pendingSortedStopBySequence = pendingStops.sort((a, b) => (a.sequence_id > b.sequence_id ? 1 : -1));
    const stopNearestDriver = pendingSortedStopBySequence.length && pendingSortedStopBySequence[0];
    const shipmentInfoByDriverNearest =
      pendingSortedStopBySequence.length && shipmentLabels.length && shipmentLabels.filter((s) => s.shipment_id === stopNearestDriver.shipment_id)[0];

    return (
      <E.Container>
        <E.MapContainer>
          <AssignmentMap assignment={assignmentInfoInTopicSelected} />
        </E.MapContainer>
        <E.InnerContainer>
          <E.Text2>{`Assignment Details`}</E.Text2>
          <E.BoxMargin>
            <E.FlexRowCenter>
              <E.FlexItemFull>
                <E.Text1>{_.get(assignment, 'label', '-')}</E.Text1>
                <E.AssignmentIdLabel>{_.get(assignment, 'id', '-')}</E.AssignmentIdLabel>
              </E.FlexItemFull>
              <E.FlexItemFull>
                <E.Text3>{`Assignment Status:`}</E.Text3>
                <E.Text4 style={{ color: statusColor }}>{_.get(assignment, 'status', '-')}</E.Text4>
              </E.FlexItemFull>
            </E.FlexRowCenter>
          </E.BoxMargin>
          <E.FlexRowCenter>
            <E.FlexItemFull>
              <E.Text5>
                <E.Label>{`Model: `}</E.Label>
                {_.defaultTo(assignment && mapLogisticToType[assignment.logistic_type], '-')}
              </E.Text5>
              <E.Text5>
                <E.Label>{`Volume: `}</E.Label>
                {_.defaultTo(completedCounter && counter && `${completedCounter} / ${counter}`, '-')}
              </E.Text5>
            </E.FlexItemFull>
            <E.FlexItemFull>
              <E.Text5>
                <TimeWindow
                  variant="tooltip"
                  label="Est. Time Window:"
                  startTs={_.get(assignment, 'predicted_start_ts')}
                  endTs={_.get(assignment, 'predicted_end_ts')}
                  timezone={_.get(assignment, 'timezone')}
                  labelSx={{ fontFamily: 'AvenirNext-Medium', fontSize: '11px', fontWeight: 600, color: '#4a4a4a' }}
                />
              </E.Text5>
              <E.Text5>
                <E.Label>{`Est. Distance: `}</E.Label>
                {_.defaultTo(assignment && `${convertMeterToMile(assignment.travel_distance).toFixed(1)} mi`, '-')}
              </E.Text5>
            </E.FlexItemFull>
          </E.FlexRowCenter>
          {assignment && user && (
            <E.BoxMargin>
              <AssignmentNote assignmentId={assignment.id} userId={user.id} />
            </E.BoxMargin>
          )}

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography component="span">Assignment History:</Typography>
            </AccordionSummary>
            <AccordionDetails>
              {assignment && (
                <HistoryListComponent baseUrl={`/events/assignments/${assignment.id}`} type="assignment" isShowTitle={false} disableScroll />
              )}
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography component="span">Shipment List:</Typography>
            </AccordionSummary>
            <AccordionDetails>
              {!!shipmentInfoByDriverNearest && (
                <E.Text6>
                  <i className="fa fa-exclamation-circle" />{' '}
                  {`Driver is currently on shipment ${_.get(shipmentInfoByDriverNearest, 'driver_label', '-')}`}
                </E.Text6>
              )}
              {filteredShowingStops &&
                !!filteredShowingStops.length &&
                filteredShowingStops &&
                filteredShowingStops
                  .filter((s) => !!s.shipment)
                  .map((stop) => {
                    return (
                      <JMiniStopBox
                        onClick={() => this.selectStop(stop)}
                        key={stop.id}
                        // style={{opacity: !stopSelected.stop || !stopSelected.stop.id || stopSelected.stop.id === stop.id ? 1.0 : 0.5}}
                        stop={stop}
                      />
                    );
                  })}
            </AccordionDetails>
          </Accordion>
        </E.InnerContainer>
      </E.Container>
    );
  }
}
export default compose(withRouter, inject('store'), observer)(AssignmentDetailPanel);
